import React from 'react';

import Switch from './formElements/Switch';

function UserAccountTypeSwitch(props) {
  const options = [
    { value: 'patient', label: 'Patient' },
    { value: 'clinician', label: 'Clinician' }
  ];

  return (
    <Switch options={options} {...props} />
  );
}

export default UserAccountTypeSwitch;
